<template>
  <div class="auth-page">
    <v-card class="auth-card" outlined>
      <div class="auth-header">
        <div>
          <h1>Crear usuario</h1>
          <p>Registra un nuevo acceso para el equipo.</p>
        </div>
        <v-btn text color="primary" :to="{ name: 'login' }">Volver al inicio de sesion</v-btn>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="email"
              label="Correo"
              outlined
              dense
              :rules="emailRules"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="username"
              label="Usuario"
              outlined
              dense
              :rules="requiredRules"
            />
          </v-col>
        </v-row>
        <v-text-field
          v-model="password"
          label="Contrasena"
          outlined
          dense
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append="showPassword = !showPassword"
          :rules="requiredRules"
        />
        <v-text-field
          v-model="roleId"
          label="Rol (UUID)"
          outlined
          dense
          placeholder="UUID_ROL_ADMIN"
          hint="Puedes dejarlo vacio si el backend asigna un rol por defecto"
          persistent-hint
        />
        <v-btn
          color="primary"
          block
          class="auth-btn"
          :loading="loading"
          :disabled="!valid || loading"
          @click="submit"
        >
          Crear usuario
        </v-btn>
        <div v-if="success" class="success-text">Usuario creado correctamente.</div>
        <div v-if="error" class="error-text">{{ error }}</div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { authService } from "../services/auth";

export default {
  name: "Register",
  data() {
    return {
      valid: false,
      email: "",
      username: "",
      password: "",
      roleId: "",
      showPassword: false,
      loading: false,
      error: "",
      success: false,
      emailRules: [
        (v) => Boolean(v) || "El correo es requerido",
        (v) => /.+@.+\..+/.test(v) || "Formato de correo invalido",
      ],
      requiredRules: [(v) => Boolean(v) || "Campo requerido"],
    };
  },
  methods: {
    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;
      this.error = "";
      this.success = false;
      this.loading = true;
      try {
        const roleIds = this.roleId ? [this.roleId] : [];
        await authService.register({
          email: this.email,
          username: this.username,
          password: this.password,
          roleIds,
        });
        this.success = true;
        this.password = "";
      } catch (err) {
        this.error = "No pudimos crear el usuario. Verifica los datos.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.auth-card {
  width: 100%;
  max-width: 720px;
  border-radius: 20px;
  padding: 28px;
}

.auth-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.auth-header h1 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
}

.auth-header p {
  margin: 0;
  color: #64748b;
}

.auth-btn {
  margin-top: 12px;
  height: 48px;
  font-weight: 700;
  text-transform: none;
}

.success-text {
  margin-top: 12px;
  color: #16a34a;
}

.error-text {
  margin-top: 12px;
  color: #dc2626;
}
</style>
